import { alert_statuses } from '@/utils/alert_statuses.js';
export default {
  name: 'AlertsStatus',
  emits: ['update:modelValue'],
  props: {
    modelValue: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      alert_statuses: alert_statuses
    };
  },
  computed: {
    status() {
      return this.alert_statuses.find(item => item.id == this.modelValue);
    },
    text() {
      if (this.status) {
        return this.status.title;
      }
      return this.modelValue;
    }
  },
  methods: {
    onClick(val) {
      this.$emit('update:modelValue', val);
    }
  }
};